import { Button, CircularProgress, Stack } from '@mui/material'
import { generateRecords as generateRecordsApi } from 'api/reports'
import moment from 'moment'
import { useCallback, useRef, useState } from 'react'
import { DateInterval, DateRangeType } from 'types/date.types'
import { BaseTableRequest } from 'types/table.types'
import { downloadArrayBuffer } from 'utils/common'
import { prepareDateRangeParams } from '../helpers/prepareDateRangeParams'

interface Props {
  rangeType: DateRangeType
  year: string
  month: string
  selectedDate: moment.Moment
  dateInterval: DateInterval
}

export const useGenerateRecords = ({
  rangeType,
  year,
  month,
  selectedDate,
  dateInterval,
}: Props) => {
  const dateParams = prepareDateRangeParams(rangeType, year, month, selectedDate, dateInterval)
  const tableRequestRef = useRef<BaseTableRequest>({})
  const [isLoading, setIsLoading] = useState(false)
  const generateRecords = async () => {
    setIsLoading(true)
    try {
      const response = await generateRecordsApi({
        ...tableRequestRef.current,
        params: dateParams,
      })
      downloadArrayBuffer(response)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  const GenerateRecordsButton = (
    <Button variant="contained" color="info" onClick={generateRecords} disabled={isLoading}>
      <Stack direction="row" alignItems="center" gap={1} position="absolute">
        {isLoading && <CircularProgress size={16} />}
      </Stack>
      Generate Report
    </Button>
  )

  const setTableRequest = useCallback((req: BaseTableRequest) => {
    tableRequestRef.current = req
  }, [])

  return { GenerateRecordsButton, tableRequest: tableRequestRef.current, setTableRequest }
}
